<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath">
            </router-view>
        </keep-alive>

        <router-view
            v-if="!$route.meta.keepAlive"
            :key="$route.fullPath"
        ></router-view>
        <!-- <router-view /> -->
    </div>
</template>

<script>
export default {
    name: "app"
};
</script>

<style lang="scss" type="text/scss">
@import "./styles/base";

html {
    height: 100%;
}

body {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

#app {
    height: 100%;
    overflow: hidden;
}
</style>
